import React from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '😰',
  title: 'El Caos Administrativo que No Para',
  desc: 'Fichas incompletas, mensajes sin responder y documentos dispersos. Cada vez que necesitás algo, perdés tiempo buscándolo o redactándolo desde cero.'
}, {
  emoji: '😩',
  title: 'El Tiempo que se va Después de Cada Sesión',
  desc: 'Terminás de atender y todavía te quedan 20 minutos de notas, mensajes y organización. Y así, todos los días.'
}, {
  emoji: '⚖️',
  title: 'La Incomodidad de Hablar de Honorarios y Límites',
  desc: 'Comunicar un aumento, responder una cancelación o sostener el encuadre sin sentirte incómodo/a sigue siendo un problema sin resolver.'
}, {
  emoji: '⏱️',
  title: 'Los Informes que Siempre Postergás',
  desc: 'Cada informe o derivación implica arrancar desde cero y escribir párrafos enteros que podrían estar ya listos.'
}];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-transparent pt-[20px] pb-[20px]" data-id="element-168">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-169">
        <div className="text-center mb-10" data-id="element-170">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-[#2f3a2c]" data-id="element-171">
            ¿TE RECONOCÉS EN ESTO?
          </h2>
          <p className="text-xl font-bold text-[#5C6851] mb-4 italic" data-id="element-172">
            ¿La carga administrativa de tu consultorio te quita más tiempo y
            energía del que debería?
          </p>
          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-173">
            Si sos psicólogo/a en ejercicio independiente, probablemente vivís
            alguna de estas situaciones:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-174">
          {situations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200" data-id="element-175">
              <div className="text-3xl mb-3" data-id="element-176">{item.emoji}</div>
              <h3 className="text-lg font-bold text-[#2f3a2c] mb-2" data-id="element-177">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-178">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}